module.exports = __webpack_public_path__ + "img/score-icon.61140d6.png";